var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('person-banner-layout');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from '../elements/cell-label';
import { PersonCell } from './person-cell';
import { BannerControls } from '../elements/banner-controls';
export var PersonBannerLayoutDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    background: #FFF;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    background: #FFF;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-grow: 1;\n    padding: ", ";\n  "], ["\n    flex-grow: 1;\n    padding: ", ";\n  "])), theme.UNIT(4))
});
var CellStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(3))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Label: styled(CellLabel)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Cell: styled(PersonCell)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  Controls: styled(BannerControls)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles)
};
export var PersonBannerLayout = function PersonBannerLayout(props) {
  var className = props.className,
      entity = props.entity;
  var label = props.label || process.env.PERSON_BANNER_LABEL || 'Profile:';
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Body, null, React.createElement(My.Label, null, label), React.createElement(My.Cell, {
    size: "banner",
    entity: entity
  })), React.createElement(My.Controls, null));
};
PersonBannerLayout.defaultProps = PersonBannerLayoutDefaultProps;
PersonBannerLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;